<template>
  <div
    v-if="companyPreferenceCenterUrlSignIn"
    class="Section PrefContent-link"
  >
    <h2>External Link To Company Preference Centre</h2>
    <a
      :href="companyPreferenceCenterUrlSignIn"
      class="Button Button--green"
      target="_blank"
      rel="noopener"
    >Preview
      Sign In</a>
    <a
      :href="companyPreferenceCenterUrlForm"
      class="Button Button--green"
      target="_blank"
      rel="noopener"
    >Preview
      Form</a>
    <button
      v-clipboard:copy="companyPreferenceCenterUrlSignIn"
      v-clipboard:success="onCopy"
      v-clipboard:error="onError"
      type="button"
      class="Button Button--ghost"
    >
      Copy Link
    </button>
    <div class="Notice Notice--info mgTop-m">
      <p class="Notice-copy">
        {{ copy.notice }}
      </p>
    </div>
  </div>
</template>

<script>
import LocalCopy from '../../../lang/en.json';
import CommonOperations from '../../../mixins/common-operations';

export default {
  mixins: [CommonOperations],
  props: {
    companyPreferenceCenterUrlForm: {
      type: String,
      required: true,
      default: '',
    },
    companyPreferenceCenterUrlSignIn: {
      type: String,
      required: true,
      default: '',
    },
  },
  data() {
    return {};
  },
  computed: {
    copy() {
      return LocalCopy.studentPreferenceCenter.externalLink;
    },
  },
  methods: {
    onCopy() {
      this.$_commonOperations_emitMessage(LocalCopy.studentPreferenceCenter.externalLink.copyToClipboard.success, 'info');
    },
    onError() {
      this.$_commonOperations_emitMessage(LocalCopy.studentPreferenceCenter.externalLink.copyToClipboard.failure, 'error');
    },
  },
};
</script>
